import React from 'react';
import { IIconProps } from './utils';

export const Civics = ({
  fill = 'currentColor',
  height = 15,
  width = 15,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 15 15" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M3 5.91263H1.875C1.25368 5.91263 0.75 5.40361 0.75 4.77571V4.62393C0.75 4.02487 1.0991 3.482 1.64079 3.2387L6.89079 0.880652C7.27864 0.706449 7.72136 0.70645 8.10921 0.880652L10.125 1.78605M3 5.91263V11.2182M3 5.91263H6M3 11.2182H1.875C1.25368 11.2182 0.75 11.7272 0.75 12.3551V13.1131C0.75 13.741 1.25368 14.25 1.875 14.25H6H13.125C13.7463 14.25 14.25 13.741 14.25 13.1131V12.3551C14.25 11.7272 13.7463 11.2182 13.125 11.2182H12M3 11.2182H6M12 5.91263H13.125C13.7463 5.91263 14.25 5.40361 14.25 4.77571V4.62393C14.25 4.02487 13.9009 3.482 13.3592 3.2387L12.75 2.96507M12 5.91263V11.2182M12 5.91263H9M12 11.2182H9M9 5.91263V11.2182M9 5.91263H6M9 11.2182H6M6 5.91263V11.2182"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
